import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchWalletBonusReport = createAsyncThunk(
  "walletBonusReport/fetchWalletBonusReport",
  async ({ page, limit, search, searchType }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("astroVani-admin-token");

      // Build params object
      const params = { page, limit };

      if (search && searchType) {
        if (searchType === "mobile") {
          params.mobileNumber = search;
        } else if (searchType === "userName") {
          params.userName = search;
        } else {
          params.search = search;
        }
      }

      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/walletBonusReport`,
        {
          params,
          headers: {
            Authorization: token,
          },
        }
      );

      // Normalize response
      const api = response.data || {};
      const rawPagination = api?.paginationDetail || {};
      const totalRecords =
        rawPagination?.totalDocs ??
        rawPagination?.totalRecords ??
        api?.totalCount ??
        api?.totalDocs ??
        0;

      const dataWithId = Array.isArray(api?.data) 
        ? api.data.map((item, index) => ({
            ...item,
            id: item._id || `${item.userId || 'row'}-${index}-${Date.now()}`
          }))
        : [];

      return {
        data: dataWithId,
        totalCount: totalRecords,
        paginationDetail: {
          ...rawPagination,
          totalRecords,
          currentPage: rawPagination?.page ?? rawPagination?.currentPage ?? 1,
          perPage: rawPagination?.limit ?? rawPagination?.perPage ?? limit,
          totalPages: rawPagination?.totalPages ?? rawPagination?.totalPages ?? 0,
        },
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong"
      );
    }
  }
);

// Initial state
const initialState = {
  data: [],
  totalCount: 0,
  status: "idle",
  error: null,
  paginationDetail: {
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    totalRecords: 0,
  },
};

// Slice
const WalletBonusReportReducer = createSlice({
  name: "walletBonusReport",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWalletBonusReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchWalletBonusReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
        state.totalCount = action.payload.totalCount;
        state.paginationDetail = action.payload.paginationDetail;
        state.error = null;
      })
      .addCase(fetchWalletBonusReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default WalletBonusReportReducer.reducer;
